(() => {
  const intro = document.querySelector('[data-tohfa-intro]');
  if (!intro || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  try {
    if (sessionStorage.getItem('tohfaIntroSeen')) return;
    sessionStorage.setItem('tohfaIntroSeen', 'true');
  } catch (error) {
    // The intro remains harmless when storage is unavailable.
  }
  intro.classList.add('is-active');
  intro.setAttribute('aria-hidden', 'false');
  const finish = () => {
    intro.classList.remove('is-active');
    intro.setAttribute('aria-hidden', 'true');
  };
  intro.addEventListener('animationend', (event) => {
    if (event.target === intro) finish();
  }, { once: true });
  window.setTimeout(finish, 2100);
})();
